import styled from 'styled-components';

const ButtonWrapper = styled.div < any > `
  display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-end;
	align-items: center;
	align-content: stretch;
  margin-top: 20px;

  .Button {
    margin-left: 20px;
    min-width: 167px;
  }

  ${({ StylesButtonWrapper }) => StylesButtonWrapper};
`;

const SpinnerContent = styled.div < any > `
  width: 80px;
  max-width: 80px;
  height: 25px;
  display: inline-block;
  position: relative;
`;

export default ButtonWrapper;

export {
  SpinnerContent,
};
